import { type PictogramIconProps } from './types';

// tools_filter
export const Filter = ({ color }: PictogramIconProps) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.2965 37.2911V27.7701L41.3683 12.9448C41.6519 12.5966 41.4119 12.0644 40.9715 12.0643H12.5555C12.1153 12.0648 11.8753 12.5967 12.1586 12.9448L24.113 27.6258V40.5038C24.1132 40.9448 24.6015 41.1972 24.9432 40.9325L29.09 37.7198C29.2204 37.6188 29.2964 37.4594 29.2965 37.2911ZM32.4066 37.2911C32.4065 38.4707 31.8683 39.5805 30.9548 40.2883L26.808 43.501C24.4161 45.3541 21.0031 43.5922 21.0029 40.5038V28.7971L9.77945 15.0113C7.79503 12.5734 9.47199 8.85206 12.5555 8.85156H40.9715C44.0553 8.85174 45.7322 12.5733 43.7475 15.0113L32.4066 28.9414V37.2911Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
};
